import React from "react";
import "./ComplaintPopup.css";

const ComplaintPopup = ({ block, blockKey, complaints = [], onClose }) => {
  if (!block) return null;

  // Status Color Logic
  const getStatusColor = (isOverdue) => {
    return isOverdue ? "#e74c3c" : "#27ae60"; // Red for overdue, green for active
  };

  // If API gives block.count use it, otherwise fallback to complaints.length
  const totalCount = typeof block.count === "number" ? block.count : complaints.length;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>

        {/* HEADER */}
        <div className="popup-header">
          <h2>{block.name} – Complaint Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {/* SUMMARY SECTION */}
        <div className="summary-section">
          <div className="summary-card">
            <h3>Total Complaints</h3>
            <span className="badge total">{totalCount}</span>
          </div>

          <div className="summary-card">
            <h3>Active</h3>
            <span className="badge active">
              {complaints.filter((c) => !c.isOverdue).length}
            </span>
          </div>

          <div className="summary-card">
            <h3>Overdue</h3>
            <span className="badge resolved">
              {complaints.filter((c) => c.isOverdue).length}
            </span>
          </div>
        </div>

        {/* COMPLAINT LIST */}
        <div className="complaints-section">
          <h3>Recent Complaints</h3>

          {complaints.length > 0 ? (
            complaints.map((c) => (
              <div className="complaint-card" key={c.grievanceId}>

                {/* COMPLAINT HEADER */}
                <div className="complaint-header">
                  <span className="comp-id">{c.grievanceId}</span>
                  <span
                    className="status"
                    style={{ background: getStatusColor(c.isOverdue) }}
                  >
                    {c.isOverdue ? "Overdue" : "Active"}
                  </span>
                </div>
               <div className="complaint-details">
                {/* DETAILS */}
                <p><strong>Description:</strong> {c.description}</p>
                <p><strong>Category:</strong> {c.category}</p>
                <p><strong>Department:</strong> {c.department}</p>
                <p><strong>Priority:</strong> {c.priority}</p>
                <p><strong>Sentiment:</strong> {c.sentiment}</p>
                <p><strong>Location:</strong> {c.location || "Not Provided"}</p>

                <p>
                  <strong>Filed On:</strong>{" "}
                  {new Date(c.createdAt).toLocaleDateString()}
                </p>

                <p>
                  <strong>Assigned Officer:</strong>{" "}
                  {c.assignedOfficer?.name || "Not Assigned"}{" "}
                  ({c.assignedOfficer?.designation || "N/A"})
                </p>

                <p>
                  <strong>Days Open:</strong> {c.daysOpen}
                </p>
</div>
              </div>
            ))
          ) : (
            <div className="no-data">No complaints available</div>
          )}
        </div>

        {/* FOOTER */}
        <div className="popup-footer">
          <p>Last Updated: {new Date().toLocaleString()}</p>
          <button className="refresh-btn" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComplaintPopup;
